import BenchSeatPage from './BenchSeatPage';

const SMALL_RECTANGLE_IMG = 'https://customer-assets.emergentagent.com/job_613a98c3-3eae-4e44-a2f7-064499799113/artifacts/xj9u57sc_small-rectangle-bench-seat-cushion.png';
const RECTANGLE_ZIP_IMG = 'https://customer-assets.emergentagent.com/job_613a98c3-3eae-4e44-a2f7-064499799113/artifacts/t71vrtbw_rectangle-bench-seat-cushion-zip.png';

const GALLERY_IMAGES = [
  { src: RECTANGLE_ZIP_IMG, alt: 'Rectangle Seat Cushion — Zip Detail' },
  { src: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80', alt: 'Modern green sofa' },
  { src: 'https://images.unsplash.com/photo-1721322800607-8c38375eef04?w=800&q=80', alt: 'Living room with sofa' },
  { src: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=800&q=80', alt: 'Contemporary living space' },
];

// Custom Cover & Foam Insert imagery — keeps the small rectangle render as the
// first image on Step 1, with the zip-detail shot as the second image.
const PRODUCT_IMAGES = {
  cover_and_foam: [
    { src: SMALL_RECTANGLE_IMG, alt: 'Rectangle Seat Cushion — Cover & Foam Insert' },
    { src: RECTANGLE_ZIP_IMG, alt: 'Rectangle Seat Cushion — Zip Detail' },
  ],
  cover_only: [GALLERY_IMAGES[1], GALLERY_IMAGES[2]],
  foam_only: [
    { src: '/foam-texture.png', alt: 'High-density foam interior' },
    { src: '/product-type-foam-only.png', alt: 'Custom-cut foam insert' },
  ],
};

const PremiumBenchSeatPage = () => (
  <BenchSeatPage
    cushionId="rectangle-bench-seat-cushion"
    galleryImages={GALLERY_IMAGES}
    productImages={PRODUCT_IMAGES}
    defaultPreviewColor={null}
    enforceDepthLessThanLength={true}
    toastName="Rectangle Seat Cushion"
    productName="Rectangle Seat Cushion"
    productDescription="A timeless rectangular cushion tailored for bench seats, window seats, and built-in seating. Made to your exact measurements with premium foam and your choice of Warwick upholstery fabric."
    pageTestId="premium-bench-seat-page"
  />
);

export default PremiumBenchSeatPage;
